import I18n from 'vue-i18n';
import Vue from 'vue';

Vue.use(I18n);

const i18n = new I18n({
  locale: 'de',
  messages: {
    de: {
      teilen: 'Teilen',
      geteilt: 'Link kopiert',
      meinTermin: 'Mein Termin',
      soFunktionierts: "So funktioniert's",
      vorschau: 'Vorschau',
      start: 'MEYLExperience startet in',
      days: 'Tag | Tage',
      hours: 'Stunde | Stunden',
      minutes: 'Minute | Minuten',
      seconds: 'Sekunde | Sekunden',
      teilnehmen: 'Jetzt teilnehmen',
      terminMitMeyle: 'Mein Termin mit MEYLE',
      gast: 'Gast',
      welcome:
        'Hallo {displayName}, hier eine Übersicht Ihres MEYLExperience Termins. Wir freuen uns auf Sie!',
      welcomeNoClient:
        'Hallo und Willkommen! Hier eine Übersicht Ihres MEYLExperience Termins. Wir freuen uns auf Sie!',
      ihrAccountManager: 'Ihr/e MEYLE Account Manager/in',
      geplanteAgenda: 'Geplante Agenda für Ihren Termin',
      onboarding: 'Vorgespräch',
      offboarding: 'Abschlussgespräch',
      island: {
        1: 'Bessere Teile und Lösungen',
        2: 'Technologiewandel',
        3: 'Digitalisierung',
        4: 'Fahrwerk & Lenkung',
        5: 'Antrieb',
        6: 'Bremse',
        7: 'Filter',
        8: 'Motor',
        9: 'Elektronik',
        10: 'Truck'
      },
      islandDescription: {
        onboarding:
          'Herzlich Willkommen bei der MEYLExperience 2020! Wir stellen Ihnen unsere Produktexperten vor und erklären Ihnen, was Sie erwartet.',
        1: 'Hier erläutern wir Ihnen unsere Differenzierungsmerkmale am Markt. Dabei erklären wir unsere Produktlinien MEYLE-HD, MEYLE-PD und MEYLE-ORIGINAL sowie unsere MEYLE-KITS und erläutern, wie wir den Aftermarket mit hochwertigen Teilen und smarten Lösungen unterstützen.',
        2: 'Diese Insel fokussiert sich auf den Technologiewandel in unserer Branche und Lösungen von MEYLE, ausgelöst durch das wachsende gesellschaftliche Bewusstsein sich nachhaltig auszurichten.',
        3: 'Hier geben wir Ihnen einen Überblick zur Digitalisierung bei MEYLE und einen ersten Einblick in unser neues "Driver Portal", in dem Sie mit wenigen Klicks Zugang zu wichtigen Informationen zur effektiven Zusammenarbeit erhalten.',
        4: 'Hier zeigen wir Ihnen, wie MEYLE als strategischer Lieferant im Bereich Fahrwerk & Lenkung mit hoher Abdeckungsrate eine Vielzahl an länger haltenden MEYLE-HD-Produkten und preisgekrönten MEYLE-KITS bietet.',
        5: 'In der Kategorie "Antrieb" konzentrieren wir uns auf schnelldrehende Ersatzteile und erklären Ihnen, wie wir z. B. mit unseren MEYLE-KITS und MEYLE-HD-Gelenkscheiben einen echten Mehrwert​ in dieser Kategorie schaffen.',
        6: 'MEYLE-Bremsen sind Ihre erste Wahl, wenn Sie mehr als nur "das Gleiche wie OE" anbieten wollen. Wir berichten hier, wie wir mit 20 Jahren Erfahrung im Bereich Bremse die bestmögliche Bremsperformance liefern.',
        7: 'In der Kategorie Filter zeigen wir Ihnen, welche MEYLE-Lösungen wir Ihnen für Öl-, Luft-, Kraftstoff- und Innenraumfilter für Ihr Portfolio bieten. Mit unseren neuen MEYLE-PD Innenraumfiltern launchen wir zur MEYLExperience eine neue Referenz in dieser Kategorie.',
        8: 'Im Bereich Motor stellen wir Ihnen unsere Fokuskategorien vor, u.a. Motor-Getriebelager und MEYLE-HD-Wasserpumpen.',
        9: 'Warum sind korrekte Daten gerade im Bereich Elektronik so wichtig? Wir sprechen mit Ihnen über genaueste Anwendungsdaten, unser rasant wachsendes Portfolio an Teilen und welche Kooperationspartner auf MEYLE vertrauen. ',
        10: 'Im Bereich "Truck" ist MEYLE die erste Wahl für bessere Teile und Lösungen, um Trucks in Bewegung zu halten – wir erläutern Ihnen warum!',
        offboarding:
          'Wir hoffen, dass Ihnen die MEYLExperience gefallen hat und einen umfassenden Einblick in die MEYLE-Welt gegeben hat. Im Anschluss haben Sie natürlich die Möglichkeit, mit ihren MEYLE-Ansprechpartnern die nächsten Schritte der Zusammenarbeit zu besprechen.'
      },
      howTo: 'So funktioniert die MEYLExperience',
      howtoMore: 'Mehr dazu',
      howto: {
        1: {
          title: 'Technik-Check vorab',
          link: '',
          copy:
            'Prüfen Sie vor dem Termin, ob Mikrofon und Lautsprecher Ihres Computers eingeschaltet sind und die Lautstärke angenehm eingestellt ist. Legen Sie sich ggf. Kopfhörer zurecht, am besten mit integriertem Mikrofon. Kontrollieren Sie auch Ihre Internetverbindung.'
        },
        2: {
          title: 'Zu Gast mit MS Teams',
          link: 'https://www.office365akademie.de/extern/teams-besprechung/',
          copy:
            'Die MEYLExperience 2020 findet über Microsoft Teams statt. Sie nutzen Microsoft Teams bisher nicht? Keine Problem, für Ihren Termin brauchen Sie weder eine Installation noch eine Anmeldung! Klicken Sie einfach auf die Option „In diesem Browser fortfahren“. Empfehlung: Nutzen Sie Chrome bzw. einen auf Chrome basierten Browser (Microsoft Edge, Opera oder Vivaldi).'
        },
        3: {
          title: 'Erste Schritte zum Termin',
          link: '',
          copy:
            'In Ihrer Einladung sowie in unserer Terminerinnerung erhalten Sie einen Link ins MEYLExperience Foyer. Ist im Foyer der Countdown zum Terminstart abgelaufen, erscheint darunter die Option „Jetzt teilnehmen“. Bitte anklicken und anschließend „In diesem Browser fortfahren“ auswählen. Ihr Browser wird Sie zunächst fragen, ob MS Teams auf Ihre Kamera und Mikrofon zugreifen darf – einfach bestätigen.'
        },
        4: {
          title: 'Sehen und gesehen werden',
          link: '',
          copy:
            'In MS Teams erhalten Sie erneut die Aufforderung „Jetzt teilnehmen“. Bevor Sie klicken, können Sie Ihren Namen eingeben. Während des Termins können andere Teilnehmer Ihren Namen und – falls Sie Kamera und Mikrofon freigeben – Sie selbst sehen bzw. hören. Mehr dazu bei „Tipps für Ihre Teilnahme“.'
        },
        5: {
          title: 'Im Warteraum',
          link: '',
          copy:
            'Nachdem Sie in MS Teams auf „Jetzt teilnehmen“ geklickt haben, befinden Sie sich zunächst im Warteraum. Hier können Sie über „Geräte“ ein bestimmtes Mikrofon, z.B. das Ihres Kopfhörers, oder eine andere Kamera auswählen und die Sprache von MS Teams einstellen. Warten Sie, bis ein MEYLE-Ansprechpartner Sie zum Termin einlässt.'
        },
        6: {
          title: 'Tipps für Ihre Teilnahme',
          link: 'https://www.office365akademie.de/extern/teams-besprechung/',
          copy:
            'Falls Sie über Ihre Webcam sichtbar sein möchten, können Sie zum Schutz Ihrer Privatsphäre den Hintergrund unscharf anzeigen lassen. Bei niedriger Bandbreite ist es empfehlenswert, Kamera und Mikrofon grundsätzlich stumm zu schalten und erst bei Bedarf zu aktivieren. Um gut sichtbar zu sein, positionieren Sie sich möglichst direkt vor Ihrer Webcam im Abstand von etwa einer Armlänge.'
        },
        7: {
          title: 'Anzeige und Funktionen',
          link: 'https://www.office365akademie.de/extern/teams-besprechung/',
          copy:
            'Während des Termins sind alle Teilnehmer in Kacheln zu sehen. Spricht oder präsentiert jemand etwas, z.B. Ihr Gastgeber, erscheint dieser größer und alle anderen Teilnehmer werden als kleine Kästchen unten am Rand angezeigt. In einer dauerhaft sichtbaren Leiste haben Sie Zugriff auf Funktionen wie z.B.: Kamera und Mikrofon an- bzw. ausschalten, Bildschirm teilen, Handheben, Chat, Teilnehmerliste und Auflegen.'
        },
        8: {
          title: 'Ihr Termin im Überblick',
          link: '',
          copy:
            'Durch einen MEYLExperience Termin führt stets einer unserer Account Manager, der sich je nach Schwerpunktthema die Moderation mit weiteren MEYLE Experten teilt. Nach einem kompakten Themeneinstieg und der Präsentation von Exponaten freuen wir uns auf den Austausch mit Ihnen im direkten Gespräch!'
        },
        9: {
          title: 'Spät dran?',
          link: '',
          copy:
            'Der Termin hat schon begonnen? Macht nichts! Während des vereinbarten Zeitraums können Sie jederzeit dazukommen – einfach hier im Foyer auf „Jetzt teilnehmen“ klicken.'
        }
      },
      // ueberblick: 'MEYLE Island Tour – Die MEYLExperience im Überblick',
      ueberblick: 'Die MEYLExperience im Überblick',
      ueberblickCopy:
        'Ob Sie Ihren Termin bei uns vor Ort oder per MS Teams wahrnehmen: Wir haben für Sie alle Kategorien und Fokusthemen in Form von Produktinseln als Gesamtansicht auf einer Karte zusammengefasst. Darauf finden Sie die Themen Ihres Termins, für die wir auf Anfrage gern jederzeit einen weiteren Termin vereinbaren.',
      ueberblickCta: 'Zur Übersichtskarte',
      vorschauTitle: 'Vorschau auf die MEYLExperience',
      vorschauHeadline: 'Die MEYLExperience 2020 erwartet Sie!',
      vorschauCopy: {
        1: 'Mit der MEYLExperience 2020 möchten wir Ihnen ein ebenso interaktives Markenerlebnis bieten, wie Sie es auch auf dem Messestand in Frankfurt erlebt hätten – nur in digitaler Form.',
        2: 'Lernen Sie unsere MEYLE-Kategorien, unsere besseren Teile und Lösungen sowie weitere Fokusthemen auf eine innovative und spannende Art und Weise kennen.',
        3: 'Wir freuen uns auf Sie!'
      },
      impressum: {
        kontakt: 'Kontakt',
        impressum: 'Impressum',
        nutzungsbedingungen: 'Nutzungsbedingungen',
        datenschutz: 'Datenschutz',
        agb: 'Allgemeine Verkaufsbedingungen',
        sitemap: 'Sitemap'
      },
      quicklinks: {
        1: 'Produkte',
        2: 'Produktlinien',
        3: 'Download-Center',
        4: 'Online-Katalog',
        5: 'App',
        6: 'Schulungen',
        7: 'Unternehmen',
        8: 'Karriere'
      }
    },
    en: {
      teilen: 'Share',
      geteilt: 'Link copied',
      meinTermin: 'My appointment',
      soFunktionierts: "Here's how it works",
      vorschau: 'Preview',
      start: 'MEYLExperience starts in',
      days: 'Day | Days',
      hours: 'Hour | Hours',
      minutes: 'Minute | Minutes',
      seconds: 'Second | Seconds',
      teilnehmen: 'Participate now',
      terminMitMeyle: 'My appointment with MEYLE',
      gast: 'Guest',
      welcome:
        "Dear {displayName}, here's an overview of your MEYLExperience appointment. We are looking forward to seeing you!",
      welcomeNoClient:
        "Hello and Welcome! Here's an overview of your MEYLExperience appointment. We are looking forward to seeing you!",
      ihrAccountManager: 'Your MEYLE Account Manager',
      geplanteAgenda: 'Planned agenda for your appointment',
      onboarding: 'Introduction',
      offboarding: 'Concluding discussion',
      island: {
        1: 'Better Parts and Solutions',
        2: 'Technology Change',
        3: 'Digitalization',
        4: 'Steering & Suspension',
        5: 'Drive Train',
        6: 'Brakes',
        7: 'Filters',
        8: 'Engine',
        9: 'Electronics',
        10: 'Truck'
      },
      islandDescription: {
        onboarding:
          'Welcome to the MEYLExperience 2020! We introduce you to our product experts and explain what you can expect.',
        1: 'Here we explain our differentiating features on the market. We describe our product lines MEYLE-HD, MEYLE-PD and MEYLE-ORIGINAL as well as our MEYLE-KITS and explain how we support the aftermarket with high-quality parts and smart solutions.',
        2: 'This island focuses upon change in technology driven by society‘s greater awareness for the need to become sustainable.',
        3: 'Here we give you an overview of digitalization at MEYLE and a first insight into our new "Driver Portal", where you can access important information for effective collaboration with just a few clicks.',
        4: 'Here we show you how MEYLE, as a strategic supplier in the field of steering & suspension with a high coverage rate, offers a variety of longer-lasting MEYLE-HD products and award-winning MEYLE-KITS.',
        5: 'In the "Drive" category we concentrate on fast moving parts and explain how we create real added value in this category e.g. with our MEYLE-KITS and MEYLE-HD flex discs.',
        6: 'MEYLE brakes are your first choice if you want to offer more than just "the same as OE". Here we share our 20 years of experience in the field of brakes and show you how we deliver the best possible braking performance.',
        7: 'In the "Filter" category we show you which MEYLE solutions for oil, air, fuel and cabin filters we can offer you for your portfolio. With our new MEYLE-PD cabin air filters we are launching a new reference in this category at the MEYLExperience.',
        8: 'In the engine section we present our focus categories, including engine transmission bearings and MEYLE-HD water pumps.',
        9: 'Why is it so important to have correct data especially in the field of electronics? We talk to you about the most accurate application data, our rapidly growing portfolio of parts and which cooperation partners rely on MEYLE. ',
        10: 'In the "Truck" category MEYLE is the first choice for better parts and solutions to keep trucks moving - we explain why!',
        offboarding:
          'We hope that you enjoyed the MEYLExperience and that we gave you a comprehensive insight into the MEYLE world. Afterwards you will of course have the opportunity to discuss the next steps in the cooperation with your MEYLE contact person.'
      },
      howTo: 'This is how the MEYLExperience works',
      howtoMore: 'Learn more',
      howto: {
        1: {
          title: 'Technology check in advance',
          link: '',
          copy:
            "Before the appointment, check that your computer's microphone and speakers are turned on and that the volume is set at a comfortable level. If necessary, put on headphones, preferably with a built-in microphone. Also please check your Internet connection."
        },
        2: {
          title: 'Guest with MS teams',
          link: '',
          copy:
            'MEYLExperience 2020 takes place via Microsoft Teams. You do not use Microsoft Teams yet? No problem, for your appointment you do not need to install or register! Just click on the option "Continue in this browser". Recommendation: Use Chrome or a Chrome-based browser (Microsoft Edge, Opera or Vivaldi). '
        },
        3: {
          title: 'First steps to the appointment',
          link: '',
          copy:
            'In your invitation and reminder you will receive a link to the MEYLExperience Foyer. Once the countdown to the start of the appointment has expired, the option "Participate now" will appear below. Please click on it and then select "Continue in this browser". Your browser will first ask you if MS Teams is allowed to access your camera and microphone - just confirm.'
        },
        4: {
          title: 'To see and be seen',
          link: '',
          copy:
            'In MS teams, you will again receive the "Participate Now" request. Before you click, you can enter your name. During the appointment, other participants can see you, your name and hear you if you share camera and microphone. For more information, see "Tips for your participation".'
        },
        5: {
          title: 'In the waiting room',
          link: '',
          copy:
            'After you have clicked on "Participate Now" in MS Teams, you will first be lead to the waiting room. There you can select a specific microphone, e.g. that of your headphones, or another camera via "Devices" and set the language of MS Teams. Please wait until a MEYLE contact person lets you in for the appointment.'
        },
        6: {
          title: 'Tips for your participation',
          link: '',
          copy:
            "If you want to be visible through your webcam, you can blur the background to protect your privacy. If your broadband is low, it is recommended that you always mute the camera and microphone and only activate them when needed. To be clearly visible, position yourself directly in front of your webcam at a distance of about an arm's length."
        },
        7: {
          title: 'Display and functions',
          link: '',
          copy:
            'During the appointment all participants are visible in tiles. If someone speaks or presents something, e.g. your host, it appears larger and all other participants are displayed in small boxes at the bottom. In a permanently visible bar you have access to functions such as : turn on/off camera and microphone, share screen, raise hand, chat, participant list and hang up.'
        },
        8: {
          title: 'Your appointment at a glance',
          link: '',
          copy:
            'A MEYLExperience appointment is always led by one of our account managers, who will share the presentation with other MEYLE experts depending on the main topic. After a compact introduction to the topic and the presentation of our product islands, we look forward to talking to you directly!'
        },
        9: {
          title: 'Running late? ',
          link: '',
          copy:
            'The appointment has already started? Don\'t worry! You can join at any time during the agreed period - just click on "Join now" here in the foyer.'
        }
      },
      // ueberblick: 'MEYLE Island Tour – Die MEYLExperience at a glance',
      ueberblick: 'The MEYLExperience at a glance',
      ueberblickCopy:
        'Whether you attend your appointment with us on site or by MS teams: We have summarised all MEYLExperience theme stations on a map. On the map you will find the different topics of your appointment - and other exciting content for which we would be happy to arrange a further appointment on request.',
      ueberblickCta: 'To the overview map',
      vorschauTitle: 'Preview to the MEYLExperience',
      vorschauHeadline: 'The MEYLExperience 2020 is expecting you!',
      vorschauCopy: {
        1: 'With the MEYLExperience 2020 we would like to offer you the same interactive brand experience that you would have had at the exhibition stand in Frankfurt - only in digital form.',
        2: 'Learn all about our MEYLE categories, our better parts and solutions as well as further focus topics in an innovative and exciting way. ',
        3: 'We are looking forward to seeing you!'
      },
      impressum: {
        kontakt: 'Contact',
        impressum: 'Imprint',
        nutzungsbedingungen: 'Conditions of use',
        datenschutz: 'Data privacy',
        agb: 'General Sales Conditions',
        sitemap: 'Sitemap'
      },
      quicklinks: {
        1: 'Products',
        2: 'Product Lines',
        3: 'Download-Centre',
        4: 'Online catalogue',
        5: 'App',
        6: 'Training and seminars',
        7: 'Company',
        8: ''
      }
    }
  }
});

export default i18n;
